import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import Pinboard from './components/Pinboard';
import Footer from './components/Footer';
import Contact from './components/Contact';
import Projects from './components/Projects';
import About from './components/About';

function App() {
  return (
    <>
    <Router>
    <div className="container">
    <Routes>
    <Route path="/" element={
      <>
      <Pinboard/>
      </>
    } />
    <Route path="/home" element={
      <>
      <Pinboard/>
      </>
    } />
    <Route path="/about" element={
      <>
      <About/>
      </>
    } />
    <Route path="/projects" element={
      <>
      <Projects/>
      </>
    } />
    <Route path="/contact" element={
      <>
      <Contact/>
      </>
    } />
    </Routes>
    </div>
    </Router>
    <Footer />
    </> 
  );
}

export default App;
